export default __webpack_public_path__ + "static/home_bodegon_peru-35621527dd396ba1cbe15041d47dd7bc.png";